<template>
  <section>
    <div class="row">
      <div id='loadingmessage'
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading">
        <p style="position: absolute; color: White; top: 40%; left: 50%;">
          <img src="../../assets/loader.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Add an Admin</h4>
            <form class="form-sample" @submit="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Name">
                    <b-form-input required type="text" v-model="name"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="User Name">
                    <b-form-input required type="text" v-model="username"></b-form-input>
                  </b-form-group>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Phone">
                    <b-form-input required type="text" v-model="phone"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Password">
                    <b-form-input required type="text" v-model="password"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Email">
                    <b-form-input required type="email" v-model="email"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Organization">
                    <b-form-input type="text" v-model="organization"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Occupation">
                    <b-form-input type="text" v-model="occupation"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row ">
                <div class="col-md-3 form-group" style="font-size:16px!important">
                  <label for="exampleInputEmail1">Please upload Image</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file" ref="file"
                    v-on:change="handleFileUpload()" />
                </div>
                <div v-if="image" class="col-md-2">
                  <div width="80px" height="80px" class="card" id="preview">
                    <img width="100%" height="100%" :src="image" />
                  </div>
                </div>
              </div>
              <hr>
              <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from "axios";
  export default {
    name: "addaturtle",
    props: {
      caption: {
        type: String,
        default: "Add a Turtle"
      },
    },
    data: () => {
      return {
        username: '',
        name: '',
        password: '',
        phone: '',
        email: '',
        organization: '',
        occupation: '',
        image: null,
        file: '',
        id: "",
        loading: false,
        id1: '',
      };
    },
    // mounted: function () {
    //   this.loadStats()
    // },
    methods: {
      resetForm() {
        this.username = ''
        this.name = ''
        this.password = ''
        this.phone = ''
        this.email = ''
        this.occupation = ''
        this.organization = ''
        this.error = ''
        this.file = null
        this.image = null
      },
      onSubmit(evt) {
        evt.preventDefault();
        var add = {};
        add['username'] = this.username
        add['name'] = this.name
        add['password'] = this.password
        add['phone'] = this.phone
        add['email'] = this.email
        add['occupation'] = this.occupation
        add['organization'] = this.organization

        add['x-auth-token'] = localStorage.getItem("token")
        axios({
          method: 'post',
          url: '/user/adminregister',
          data: add,

        })
          .then(response => {
            this.msg = response.data.msg;
            this.id = response.data._id;
            this.loading = "false";
            if (response.data.status === true) {
              this.id1 = response.data.data._id
              let formData = new FormData();
              formData.append("token", localStorage.getItem("token"));
              formData.append("id", this.id1);
              formData.append("image", this.file);
              this.loading = true;

              axios({
                method: "post",
                url: "/user/imageupload",
                data: formData,
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
                .then(response => {
                  this.resetForm()
                  alert('Admin added Successfully')
                  this.$router.push({ path: "/adminslist" });
                  this.loading = false
                })
                .catch(e => {
                  this.loading = false
                  this.error = e.response.data.msg
                  alert('Admin added without image')
                })
            }
            if (response.data.status === false) {
              this.loading = false

              alert('Please try again')
            }
          })
          .catch(err => {
            this.loading = false

            alert('Please try again')
          });
      },

      handleFileUpload() {
        this.file = this.$refs.file.files[0];
        this.image = URL.createObjectURL(this.file);
      },

    }
  };
</script>

<style scoped>
  .card-body>>>table>tbody>tr>td {
    cursor: pointer;
  }
</style>